<template>
  <div class="SmsLoginPage">
    <div class="loginBox">
      <div class="title">欢迎登录麦绿素</div>
      <div class="text">将使用手机号作为用户帐号完成登录/注册</div>
      <div class="inputBox">
        <input
          v-model="phone"
          type="number"
          class="input"
          placeholder="请输入手机号"
        />
      </div>
      <div
        class="submitBtn"
        :class="{ submitBtn_disabled: phone == '' }"
        @click="clickGetCaptcha"
      >
        获取验证码
      </div>
      <div class="agreeBox">
        <img
          class="checkBox"
          v-show="!isAgree"
          src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v2/checkbox_uncheck.png"
          alt=""
          @click="isAgree = !isAgree"
        />
        <img
          class="checkBox"
          v-show="isAgree"
          src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v2/checkbox_checked.png"
          alt=""
          @click="isAgree = !isAgree"
        />
        <div class="agreeText">
          已阅读并同意<span class="deepColor">《服务协议》</span>
        </div>
      </div>
    </div>

    <transition name="fade">
      <loading v-show="loading"></loading>
    </transition>
  </div>
</template>

<script>
// 引入API
import * as Http from "@/api/HttpService.js";
export default {
  data: function () {
    return {
      isAgree: false,
      phone: "",
      channelCode: "",
      loading: false,
    };
  },
  mounted: function () {
    this.channelCode = this.$route.query.channelCode;
    window.localStorage.setItem("channelCode_AI", this.channelCode);
  },
  methods: {
    // 点击获取验证码
    clickGetCaptcha: async function () {
      if (!this.isAgree) {
        this.$toast("请阅读并同意《服务协议》");
        return;
      }
      if (this.phone == "") {
        return;
      } else {
        let params = {
          system: this.channelCode,
          phone: this.phone,
        };
        this.loading = true;
        await Http.getCaptcha(params)
          .then(({ res }) => {
            console.log(res);
            if (res.originalData.code == "SUCCESS") {
              this.$router.push({
                name: "InputCaptchaPage",
                params: {
                  phone: this.phone,
                  channelCode: this.channelCode,
                },
              });
            } else {
              this.$toast(res.originalData.msg || "网络异常");
            }
          })
          .catch((err) => {
            console.log(err);
            this.$toast("网络异常");
          });
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss">
@import "./SmsLoginPage.scss";
</style>
